import TimeStampGenerator from "../../TimeStampGenerator";

export class BaseRequest {
  private SessionID: string | null;
  // private TS: number;
  constructor(SessionID: string | null) {
    this.SessionID = SessionID;
    // this.TS = TimeStampGenerator();
  }
}
